<template>
  <div class="auditLog">
    <v-row>
      <v-col cols="12">
        <div class="topPanel">
          <div class="parameterInputs">
            <v-select
              label="Select User:"
              v-model="searchParameters.user"
              :items="this.users"
            ></v-select>
            <v-text-field label="State No:" v-model="searchParameters.stateNo"></v-text-field>
            <DatePicker label="From Date:" v-model="searchParameters.fromDate"></DatePicker>
            <DatePicker label="To Date:" v-model="searchParameters.toDate"></DatePicker>
          </div>
          <div class="lowerTopPanel">
            <div class="buttons">
              <v-btn color="primary" class="mr-4" @click="fetchInitialData"> Search </v-btn>
              <v-btn color="primary" class="mr-4" @click="loadLogData" :disabled="isAllDataLoaded">
                Load more data...
              </v-btn>
            </div>
            <div class="searchBox">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Filter"
                class="mb-2 search"
                single-line
                hide-details
              ></v-text-field>
            </div>
          </div>
        </div>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page.sync="itemsPerPage"
          :footer-props="{ 'items-per-page-options': [20, 25, 50, 100] }"
          :loading="loading"
          :search="search"
          :calculate-widths="true"
          :page.sync="currentPage"
          item-key="LogID"
          loading-text="Loading log data..."
          class="auditLogTable"
          dense
        >
          <template v-slot:[`item.AuditDate`]="{ item }">
            <span>{{ item.AuditDateTime }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  components: { DatePicker },
  name: 'MemberAudit',
  data() {
    return {
      loading: false,
      headers: [
        { text: 'Audit Date', value: 'AuditDate' },
        { text: 'Action', value: 'AuditType' },
        { text: 'Column', value: 'ColumnName' },
        { text: 'Old Value', value: 'OldValue' },
        { text: 'New Value', value: 'NewValue' },
      ],
      items: [],
      users: [],
      currentPage: 1,
      itemsPerPage: 20,
      search: null,
      isAllDataLoaded: false,
      searchParameters: {
        user: '',
        stateNo: '',
        fromDate: '',
        toDate: '',
      },
    };
  },
  computed: {},
  created() {
    //this.loadLogData();
    this.loadUsers();
  },

  mounted: function () {
    this.$root.currentPage = 'MemberAudit';
  },

  methods: {
    async loadLogData() {
      this.loading = true;
      const startItemNumber = this.items.length + 1;
      const isNeedIncreasePage = this.currentPage == this.items.length / this.itemsPerPage;
      try {
        let response = await this.$api.get(
          `security/LoadAuditTable?row=${startItemNumber}&userName=${this.searchParameters.user}&auditDateFrom=${this.searchParameters.fromDate}&auditDateTo=${this.searchParameters.toDate}&TRN=${this.searchParameters.stateNo}`
        );
        if (response.data && response.data.length > 0) {
          this.items = this.items.concat(response.data);
          if (isNeedIncreasePage) this.currentPage++;
        } else {
          this.isAllDataLoaded = true;
        }
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },

    fetchInitialData() {
      this.items = [];
      this.currentPage = 1;
      this.search = null;
      this.isAllDataLoaded = false;
      this.loadLogData();
    },

    async loadUsers() {
      try {
        let response = await this.$api.get('security/LoadUsers');
        if (response.data && response.data.length > 0) {
          let usernames = response.data.map((x) => x.UserName);
          this.users = usernames;
        } else {
          this.users = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss">
.auditLog {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;

  .topPanel {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    .parameterInputs {
      display: flex;
      gap: 12px;
    }

    .lowerTopPanel{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;

      .buttons {
        display: flex;
        margin-top: 10px;
      }

      .searchBox {
        padding-top: 0px;
        max-width: 500px;

        .search{
          max-width: 500px;
        }
      }

    }
  }
  .v-data-table tbody tr {
    cursor: default;
  }
}
</style>
